
import React, { Component } from 'react';
import ValidationField from './ValidationField';

class ValidationBlock extends Component {
  render() {
    let { validation } = this.props;
    return (
      <div>
      {
        validation.constraints.map((c, index) => {
          return (<ValidationField key={index} state={c.state} text={c.text} />)
        })
      }
      </div>
    )
  }
}

export default ValidationBlock;



// WEBPACK FOOTER //
// ./src/components/FieldGroup/ValidationBlock.js